'use client';

import { useEffect } from 'react';

import { CrashState } from '@/components/page-states';
import { captureError } from '@/lib/capture-error';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // ChunkLoadError means the user has a stale tab open after a deployment.
    // Auto-reload to fetch the new chunks instead of showing an error screen.
    if (error.name === 'ChunkLoadError') {
      window.location.reload();
      return;
    }

    captureError({
      error,
      source: 'ui_crash',
      context: { digest: error.digest },
    });
  }, [error]);

  // -mb-40 gives back the <main> bottom padding, so the block centres on the
  // viewport rather than on the space above the padding.
  return (
    <div className="-mb-40 flex flex-1 items-center justify-center px-4 py-16">
      <CrashState onRetry={reset} />
    </div>
  );
}
